module.exports = "/app_store_button-7b2765f17568d0966e838197331a8398.svg";